import React, { useEffect } from "react";

import { Helmet } from "react-helmet";

import { MARKETING_YANDEX_ID } from "@/marketing/constants";
import { getMetricaCID, initYandexMetrika } from "@/marketing/yandexMetrika";
import { injectScript, runAfterWindowLoad } from "@/utils/thirdPartyScripts";

const METRIKA_SCRIPT_URL = `https://mc.yandex.ru/metrika/tag.js?id=${MARKETING_YANDEX_ID}`;

/**
 * Яндекс.Метрика (SEO #12, task 4575).
 *
 * Разделено намеренно, по согласованию с владельцем аналитики:
 * — **очередь `ym` и вызов `init` создаются в эффекте сразу, до вставки `tag.js`**. Это несколько
 *   сотен байт, зато ни одно событие не теряется: цели, отправленные до загрузки скрипта,
 *   копятся в очереди и уходят, как только `tag.js` подгрузится. Порядок обязателен:
 *   `tag.js` забирает очередь только при своей загрузке. Через `<Helmet>` очередь не создаём:
 *   react-helmet пишет теги в `<head>` в `requestAnimationFrame`, и `tag.js` может выполниться раньше;
 * — **сам `tag.js` (~280 КБ) грузится после события `load`** со страховочным таймером.
 *   Откладывать «по клику» нельзя — так терялись бы визиты с быстрым уходом.
 */
const YandexMetrikaHelmet = () => {
  useEffect(() => {
    if (!MARKETING_YANDEX_ID) {
      return;
    }

    initYandexMetrika();
    // Запрос ClientID встаёт в очередь сразу: бэку он нужен в заголовке X-Metrica-CID.
    getMetricaCID();
    runAfterWindowLoad(() =>
      injectScript(METRIKA_SCRIPT_URL));
  }, []);

  if (!MARKETING_YANDEX_ID) return null;

  return (
    <Helmet>
      <noscript>
        {`<div><img src="https://mc.yandex.ru/watch/${MARKETING_YANDEX_ID}" style="position:absolute; left:-9999px;" alt="" /></div>`}
      </noscript>
    </Helmet>
  );
};

export default YandexMetrikaHelmet;
